if (!window.customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    connectedCallback() {
      const formId = this.getAttribute('form');
      const form = document.getElementById(formId);
      const input = form?.querySelector('input[name="id"]');

      if (!input) return;

      this._lastVariant = null;
      this._fetchTimer = null;

      const debouncedFetch = (id) => {
        clearTimeout(this._fetchTimer);
        this._fetchTimer = setTimeout(() => this.fetchAvailability(id), 50);
      };

      this.observer = new MutationObserver(() => debouncedFetch(input.value));
      this.observer.observe(input, { attributes: true, attributeFilter: ['value'] });

      input.addEventListener('change', () => debouncedFetch(input.value));

      // Only fetch on mount if Liquid didn't already render content
      if (!this.innerHTML.trim()) {
        this.fetchAvailability(input.value);
      } else {
        // Mark current variant so we don't refetch it
        this._lastVariant = input.value;
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this._fetchTimer);
    }

    async fetchAvailability(variantId) {
      if (!variantId) {
        this.innerHTML = '';
        this._lastVariant = null;
        return;
      }

      if (variantId === this._lastVariant) return;
      this._lastVariant = variantId;

      try {
        const response = await fetch(
          `${Shopify.routes.root}variants/${variantId}?section_id=pickup-availability`
        );
        const html = await response.text();
        const div = document.createElement('div');
        div.innerHTML = html;
        const newContent = div.querySelector('pickup-availability');
        if (newContent && newContent.innerHTML.trim() !== '') {
          this.replaceChildren(...newContent.childNodes);
        }
      } catch (e) {
        console.error('Pickup availability fetch failed:', e);
      }
    }
  }

  window.customElements.define('pickup-availability', PickupAvailability);
}